export const url = {
    base: 'https://api.agendaenlinea.cl/api',
    baseURL: 'https://api.agendaenlinea.cl/api',
    urlGlobal: 'https://api.agendaenlinea.cl/api',
}
// export const env = {
//     base: 'https://api.agendaenlinea.cl/api',
//     baseURL: 'https://api.agendaenlinea.cl/api',
//     urlGlobal: 'https://api.agendaenlinea.cl/api',
   
//     DEVbase: 'https://api.agendaenlinea.cl/api',
//     DEVbaseURL: 'https://api.agendaenlinea.cl/api',
//     DEVurlGlobal: 'https://api.agendaenlinea.cl/api',

//     LOCALbase: 'https://api.agendaenlinea.cl/api',
//     LOCALbaseURL: 'https://api.agendaenlinea.cl/api',
//     LOCALurlGlobal: 'https://api.agendaenlinea.cl/api',

//     enviroment: 'production'
// }
export const env = {
    baseURL: 'https://api.agendaenlinea.cl/api',
    //baseURL: 'https://api.agendaenlinea.cl/api',
    DEVbaseURL: 'https://api-amol.appmedic.cl/api',
    LOCALbaseURL: 'http://api-amol.local/api',
    // urlGlobal: 'https://api.agendaenlinea.cl/api/',
    urlGlobal: 'https://globales.agendaenlinea.cl/',
    enviroment: 'production'
}


// WEBPACK FOOTER //
// ./src/config/env.js